__turbopack_context__.v({
  "back-to-top": "index-module-scss-module__WpZUwW__back-to-top",
  "is-active": "index-module-scss-module__WpZUwW__is-active",
});
